import _ from 'lodash';
import {ReactNode} from 'react';
import {SnackbarType} from '@treez-ui/core/feedback/modals';
import {
    HorizontalAnchorPosition,
    VerticalAnchorPosition,
} from '@treez-ui/core/feedback/modals/Snackbar';
import {SNACKBAR_ACTION, SnackbarActionValue} from '~/redux/actions/SnackbarActions';
import {ReducerActionAttributes} from './RootReducer';

export interface SnackbarState {
    content?: ReactNode;
    onClose: () => void;
    onEnter?: () => void;
    open: boolean;
    type: SnackbarType;
    autoHideDuration: number;
    horizontalAnchor?: HorizontalAnchorPosition;
    verticalAnchor?: VerticalAnchorPosition;
}

const DEFAULT_SNACKBAR_STATE = {
    open: false,
    type: SnackbarType.GENERAL,
};

const {CLEAR_SNACKBAR, SHOW_SNACKBAR} = SNACKBAR_ACTION;

const SnackbarReducer = (
    state = DEFAULT_SNACKBAR_STATE,
    action: ReducerActionAttributes<SNACKBAR_ACTION, SnackbarActionValue>
) => {
    const {type, value} = action;

    switch (type) {
        case CLEAR_SNACKBAR:
            return {
                ...DEFAULT_SNACKBAR_STATE,
                open: false,
            };
        case SHOW_SNACKBAR:
            return {
                ...value,
                open: true,
            };
        default:
            return state;
    }
};

export default SnackbarReducer;
